import { Breadcrumb, Card, Col, EventHandler, InputField, Label, PrimaryButton, Quantity, Row } from "client/CommonComponents"
import { isNumber } from "utils";
import AssessmentQuestion from "../AssessmentQuestion";
import './CreateNewAssessment.scss';

const CreateNewAssessment = (props?:any) =>{
    const { 
        assessmentTitle, 
        onChangeAssessmentTitle, 
        passingPercentage, 
        onChangePassingPercentage,
        quantity,
        error,
        addQuestionBtnClicked 
    } = props

    return(<>
        <div className='breadCrumbBlock'>
            <EventHandler onEvent={props.handleClickBack} data-attribute="CreateNewAssessment_Default_EventHandler">
                <div className='backButton mb-sm-2 mb-3'>
                    <span className="fa fa-chevron-left"></span> Back
                </div>
            </EventHandler>
            <div className='breadcrumbList'>
                <Breadcrumb items={props.breadcrumlist} maxDisplayedItems="5"  data-attribute="CreateNewAssessment_Default_Breadcrumb" />
            </div>
        </div>
        <div className="mb-3">
        <Card data-attribute="CreateNewAssessment_Default_Card">
        <p className='headingText mb-0'>CREATE NEW ASSESSMENT</p>
        <p className='subText mb-2'>Select below options to create new assessment</p>
  
        <Row className="pe-xl-4">
            <Col xs={12} sm={4} md={4} lg={3} xl={3} className='mb-md-3 mb-3'>
                <Label required data-attribute="CreateNewAssessment_Default_Label">Assessment Title</Label>
                <InputField 
                placeholder="Enter Assessment Title" 
                value={assessmentTitle}
                onChange={(e:any)=>onChangeAssessmentTitle(e.target.value)}
                className={error?.assessementError ? 'controlValidation' : ''}
                 data-attribute="CreateNewAssessment_Default_Input" />
                {error?.assessementError ? <p className='validMessage'>{error?.assessementError}</p> : ""}
            </Col>
            <Col xs={12} sm={4} md={4} lg={3} xl={2} className='mb-lg-3 mb-md-0 mb-3'>
                <Label required data-attribute="CreateNewAssessment_Default_Label_2">Passing Score Percentage</Label>
                <InputField 
                placeholder='Enter Passing Percentage' 
                suffix='%'
                value={passingPercentage}
                onChange={(e:any) => onChangePassingPercentage(e.target.value)}
                onKeyPress={(event: any) => { isNumber(event) }}
                className={error?.passingPercentageError ? 'controlValidation' : ''}
                 data-attribute="CreateNewAssessment_Default_Input_2" />
                {error?.passingPercentageError ? <p className='validMessage'>{error?.passingPercentageError}</p> : ""}
            </Col>
            <Col xs={9} sm={3} md={3} lg={2} xl={1} className='mb-md-0 mb-3'>
                <Label required data-attribute="CreateNewAssessment_Default_Label_3"># of Question</Label>
                <Quantity
                    increment={props?.incrementQuantity}
                    decrement={props?.decrementQuantity}
                    value={quantity}
                    disableFlg={quantity <= 1 || addQuestionBtnClicked}
                    onChange={props?.onChangeQuantity}
                    disabledQuantity = {addQuestionBtnClicked}
                    disable = {addQuestionBtnClicked}
                 data-attribute="CreateNewAssessment_Default_Quantity" />
            </Col>
            <Col xs={3} sm={1} md={1} lg={1} xl={1} className="" >
                <PrimaryButton text='Add Question' className='pull-right add-question' onClick={props?.onClickAddQuestionBtn} disabled={addQuestionBtnClicked} data-attribute="CreateNewAssessment_Default_Button" />
            </Col>                 
        </Row>
        </Card>
        </div>
        {props?.showAssessmentQuestion ?
            <AssessmentQuestion
                quantity={quantity}
                assessmentTitle={assessmentTitle}
                passingPercentage={passingPercentage}
                handleClickBack={props.handleClickBack}
            />
            : ''}   
    </>)
}

export default CreateNewAssessment;